import { useEffect, useRef, useState } from 'react';

/**
 * Fake progress for the ~75s poster bake. Eases toward ~90% by 75s, then creeps
 * asymptotically toward a ~96% cap — it never reaches 100% on its own; the poster
 * actually appearing (the card swaps out of the baking state) IS the real 100%.
 * Keeps its own start time so it survives the parent's 5s poll re-renders.
 */
export function BakingBar({
  label = '🎨 baking your poster…',
  compact = false,
}: {
  label?: string;
  compact?: boolean;
}) {
  const start = useRef<number>(Date.now());
  const [pct, setPct] = useState(4);

  useEffect(() => {
    const tick = () => {
      const t = (Date.now() - start.current) / 1000;
      const p = 100 * (1 - Math.exp(-t / 32.6)); // ≈90% at 75s, then asymptotic creep
      setPct(Math.min(96, Math.max(4, p)));
    };
    tick();
    const iv = setInterval(tick, 500);
    return () => clearInterval(iv);
  }, []);

  return (
    <div className={`baking-bar${compact ? ' compact' : ''}`}>
      {!compact && <div className="baking-bar-label">{label}</div>}
      <div className="baking-bar-track">
        <div className="baking-bar-fill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
